import { useEffect, useRef, useState } from 'react';
import { usePopper } from 'react-popper';
import { toast } from 'react-toastify';

const parentMenuItems = [
  {
    id: 'block_above',
    label: 'Add a block above',
    src: '/assets/images/right_.png',
  },
  {
    id: 'block_below',
    label: 'Add a block below',
    src: '/assets/images/right_.png',
  },
  { id: 'delete', label: 'Delete', src: '/assets/images/confirm_delete.svg' },
];

const childMenuItems = [
  { id: 'chapter_header', label: 'Chapter header' },
  { id: 'section_header', label: 'Section header' },
  { id: 'small_header', label: 'Small header' },
  { id: 'paragraph', label: 'Paragraph' },
  { id: 'image', label: 'Image' },
  { id: 'video', label: 'Video' },
  { id: 'audio', label: 'Audio' },
];

const BlockComponent = ({
  blockId,
  chapterId,
  blockType,
  chapIndex,
  blockIndex,
  setShowBlock,
  handleAddChapter,
  paragraphObj = {},
  sectionIndex = -1,
  paragraphIndex = -1,
  handleAddMediaBlock,
  handleChapterDelete,
  handleAddSectionBlock,
  handleAddChapterSubBlock,
  handleAddSmallHeaderBlock,
  ...props
}) => {
  const childRef = useRef(null);
  const dropdownRef = useRef(null);
  const clickInsideRef = useRef(false);

  const [activeItem, setActiveItem] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [referenceElement, setReferenceElement] = useState(null);
  const [showChildDropdown, setShowChildDropdown] = useState(false);

  const { attributes } = usePopper(referenceElement, popperElement, {
    placement: 'right-start',
    modifiers: [
      {
        name: 'offset',
        options: { offset: [0, 4] },
      },
    ],
  });

  const handleParentClick = (menuItem) => {
    let pType = '';
    if (Object.keys(paragraphObj).length > 0) {
      pType = paragraphObj.type === 'small_header' ? 'small header' : paragraphObj.type;
      if (paragraphObj.media.length > 0) {
        pType = paragraphObj.media[0].type;
      }
    }

    if (menuItem.id === 'delete') {
      handleChapterDelete(blockType, blockId, chapIndex, sectionIndex, paragraphIndex, pType);
    }
  };

  const handleParentMouseOver = (menuItem) => {
    setActiveItem(menuItem.id);
    if (menuItem.id === 'block_above' || menuItem.id === 'block_below') {
      setShowChildDropdown(true);
    } else {
      setShowChildDropdown(false);
    }
  };

  useEffect(() => {
    const handleDocumentClick = (e) => {
      if (clickInsideRef.current) {
        clickInsideRef.current = false; // reset for next time
        return;
      }
      setShowChildDropdown(false);
      setActiveItem(null);
    };

    document.addEventListener('mousedown', handleDocumentClick);
    return () => {
      document.removeEventListener('mousedown', handleDocumentClick);
    };
  }, []);

  return (
    <div
      className='block-component'
      ref={dropdownRef}
      onMouseDown={() => {
        clickInsideRef.current = true;
      }}
    >
      {/* Parent Dropdown */}
      <div
        className='drop_down_list_create-center'
        style={{ display: 'block', height: 'max-content' }}
      >
        <ul className='block-adder d-flex flex-column gap-2'>
          {parentMenuItems.map((menuItem) => (
            <li
              key={menuItem.id}
              className='block-adder cursor block-parent d-flex justify-content-between column-gap-5'
              style={{
                background: activeItem === menuItem.id ? '#f0f0ef' : undefined,
              }}
              ref={(el) => {
                if (activeItem === menuItem.id && menuItem.id !== 'delete') {
                  setReferenceElement(el);
                }
              }}
              onMouseOver={() => handleParentMouseOver(menuItem)}
              onClick={(e) => {
                e.stopPropagation();
                handleParentClick(menuItem);
              }}
            >
              {menuItem.label}

              <img
                src={menuItem.src}
                className='block-adder'
                alt='icon'
                width={20}
                height={20}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleParentClick(menuItem);
                }}
                style={{
                  transform:
                    activeItem === menuItem.id && menuItem.id !== 'delete' ? 'rotate(180deg)' : '',
                }}
              />
            </li>
          ))}
        </ul>
      </div>

      {/* Child Dropdown (Popover) */}
      {showChildDropdown && (
        <div
          className='drop_down_list_create-center position-relative'
          ref={(node) => {
            setPopperElement(node);
            childRef.current = node;
          }}
          style={{
            zIndex: 9999,
            background: 'white',
            borderRadius: '0px 4px 4px 4px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
            top: activeItem === 'block_above' ? '8px' : '60px',
          }}
          {...attributes.popper}
          onMouseDown={() => {
            clickInsideRef.current = true; // Allow child click
          }}
        >
          <ul className='w-100 block-adder'>
            {childMenuItems.map((childItem) => (
              <li
                key={childItem.id}
                className='block-adder cursor block-parent d-flex justify-content-between column-gap-5'
                onClick={(e) => {
                  e.stopPropagation();
                  const position = activeItem === 'block_above' ? -1 : 1;

                  if (blockType === 'chapter' && childItem.id === 'chapter_header')
                    handleAddChapter(position, props.chapInd);
                  /**
                   * =========================================================
                   *   Add Block At Chapter level for Paragraph/Small Header
                   * =========================================================
                   */ else if (
                    blockType === 'chapter' &&
                    ['paragraph', 'small_header'].includes(childItem.id)
                  ) {
                    if (position === -1 && props.chapInd === 0)
                      return toast.error('Can not Add Section block at specified position.');
                    else if (position === -1 && props.chapInd > 0) {
                      const chapIndex = props.chapInd - 1;
                      const chapter = props.book.chapters[chapIndex];
                      handleAddChapterSubBlock(chapter, chapter.sections.length + 1, childItem.id);
                    } else
                      handleAddChapterSubBlock(
                        props.chap,
                        props.chap.sections.length + 1,
                        childItem.id
                      );
                  } else if (
                    /**
                     * =========================================================
                     *   Add Block At Section level for Paragraph/Small Header
                     * =========================================================
                     */
                    blockType === 'section' &&
                    ['paragraph', 'small_header'].includes(childItem.id)
                  ) {
                    if (position === 1)
                      handleAddSmallHeaderBlock(
                        position,
                        -1,
                        props.chap,
                        props.section._id,
                        childItem.id
                      );
                    else if (position === -1 && blockIndex === 0)
                      handleAddChapterSubBlock(
                        props.chap,
                        blockIndex === 0 ? -1 : position === -1 ? blockIndex + 1 : blockIndex + 2,
                        childItem.id
                      );
                    else if (position === -1 && blockIndex > 0) {
                      const section = props.chap.sections.slice(blockIndex - 1)[0];
                      handleAddSmallHeaderBlock(
                        position,
                        section.paragraphs.length - 1,
                        props.chap,
                        section._id,
                        childItem.id
                      );
                    } else if (position === -1 && chapIndex === 0)
                      toast.error('Can not Add block at specified position.');
                    // handleAddSectionBlock(position, props.secIndex, props.chap);
                  } else if (
                    /**
                     * =========================================================
                     *   Add Block At Chapter/Section level for Section Header
                     * =========================================================
                     */
                    (blockType === 'section' || blockType === 'chapter') &&
                    childItem.id === 'section_header'
                  ) {
                    if (position === -1 && props.chapInd > 0 && blockType === 'chapter') {
                      const chapIndex = props.chapInd - 1;
                      const chapter = props.book.chapters[chapIndex];
                      handleAddSectionBlock(
                        chapter.sections.length > 0 ? 1 : -1,
                        chapter.sections.length - 1,
                        chapter
                      );
                    } else if (position === -1 && blockType === 'section') {
                      handleAddSectionBlock(position, blockIndex, props.chap);
                    } else
                      handleAddSectionBlock(position, props.chap.sections.length - 1, props.chap);
                  } else if (
                    /**
                     * =========================================================
                     *     Add Block At Chapter level for image/audio/video
                     * =========================================================
                     */
                    blockType === 'chapter' &&
                    ['image', 'video', 'audio'].includes(childItem.id)
                  ) {
                    if (position === -1 && props.chapInd === 0)
                      return toast.error('Can not Add block at specified position.');

                    if (position === -1 && props.chapInd > 0) {
                      const chapIndex = props.chapInd - 1;
                      const chapter = props.book.chapters[chapIndex];
                      if (chapter?.sections?.length) {
                        const section = chapter.sections.slice(-1)?.[0];
                        if (section?._id) {
                          handleAddMediaBlock(
                            position,
                            section.paragraphs.length,
                            chapter,
                            section._id,
                            childItem.id
                          );
                        }
                      }
                    } else if (position === 1 && props.chap.sections.length) {
                      const section = props.chap.sections.slice(-1)?.[0];
                      if (section?._id) {
                        handleAddMediaBlock(
                          position,
                          section.paragraphs.length,
                          props.chap,
                          section._id,
                          childItem.id
                        );
                      }
                    }
                  } else if (
                    /**
                     * =========================================================
                     *     Add Block At Section level for image/audio/video
                     * =========================================================
                     */
                    blockType === 'section' &&
                    ['image', 'video', 'audio'].includes(childItem.id)
                  ) {
                    if (position === -1) {
                      const sectionIndex = props.chap.sections.findIndex(
                        (item) => item._id === props.section._id
                      );
                      if (sectionIndex >= 1) {
                        const section = props.chap.sections[sectionIndex - 1];
                        handleAddMediaBlock(
                          position,
                          section.paragraphs.length,
                          props.chap,
                          section._id,
                          childItem.id
                        );
                      }
                    } else if (position === 1)
                      handleAddMediaBlock(
                        position,
                        -1,
                        props.chap,
                        props.section._id,
                        childItem.id
                      );
                  } else if (
                    blockType === 'paragraph' &&
                    ['paragraph', 'small_header'].includes(childItem.id)
                  )
                    handleAddSmallHeaderBlock(
                      position,
                      blockIndex,
                      props.chap,
                      props.section._id,
                      childItem.id
                    );
                  else if (blockType === 'paragraph' && childItem.id === 'section_header')
                    handleAddSectionBlock(position, props.secIndex, props.chap);
                  else if (blockType === 'paragraph' && childItem.id === 'chapter_header')
                    handleAddChapter(position, props.chapInd, props.chap);
                  else if (
                    blockType === 'section' &&
                    ['image', 'video', 'audio'].includes(childItem.id)
                  )
                    handleAddMediaBlock(
                      position,
                      position === -1 ? '' : -1,
                      props.chap,
                      props.section._id,
                      childItem.id
                    );
                  else if (
                    blockType === 'paragraph' &&
                    ['image', 'video', 'audio'].includes(childItem.id)
                  )
                    handleAddMediaBlock(
                      position,
                      blockIndex,
                      props.chap,
                      props.section._id,
                      childItem.id
                    );

                  setShowBlock(false); // or whatever action
                }}
              >
                {childItem.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default BlockComponent;
